import React from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'

import AccountMonitoring from '../account_monitoring'

/* Cross-client admin pages.
 *
 * Unlike the per-client route files there is no CLIENT path segment: these pages call
 * endpoints that take no client argument, so mounting them under /{client} would render
 * the identical page at seven URLs. `admin` matches no CLIENTS[*].NAME, so it cannot
 * shadow a client subtree.
 */
const adminRouter = createBrowserRouter([
  {
    id: 'dashboard-admin-route',
    path: 'admin',
    children: [
      {
        id: 'admin-account-monitoring',
        path: 'account_monitoring',
        element: <AccountMonitoring />
      },
      {
        id: 'admin-redirect',
        path: '*',
        element:
          <Navigate
            to={'account_monitoring'}
            replace={true}
          />
      },
    ]
  }
])

export default adminRouter
